import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import DevModeProvider from './components/devmode/provider';

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <DevModeProvider>
                <App />
            </DevModeProvider>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);
